import service from "services/maintenance/leaveTypeService";
import { SickOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const loanTypeResource = {
    title: "Leave Types",
    singular: "Leave Type",
    displayField: "description",
    service: service,
    pageIcon: SickOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.LEAVE_TYPE,
    columns: [
        {
            field: "leaveTypeCode",
            header: "Leave Type",
            width: "15%"
        },
        {
            field: "description",
            header: "Leave Description"
        },
        {
            field: "basicCredits",
            header: "Basic Credits",
            type: "number"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],
    fields: [
        {
            name: "leaveTypeCode",
            label: "Leave Type",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        },
        {
            name: "basicCredits",
            label: "Basic Credits",
            type: "number",
            required: true
        },
        {
            name: "renewCredits",
            label: "Renew Credits",
            type: "bool",
            required: true,
            defaultValue: false
        },
        {
            name: "carryOver",
            label: "Carry Over",
            type: "bool",
            defaultValue: false
        },
        {
            name: "convertible",
            label: "Convertible",
            type: "bool",
            defaultValue: false
        }
    ],
    searchFields: ["leaveTypeCode", "description"]
};

export default loanTypeResource;
